import { gql } from '../types/generated';

export const CREATE_LOCATION_OVERRIDE = gql(`
  mutation createLocationOverride($oktaId: String!, $ipAddress: String!, $zipCode: String!, $countryCode: String!) {
    createLocationOverride(oktaId: $oktaId, ipAddress: $ipAddress, zipCode: $zipCode, countryCode: $countryCode) {
      status
    }
  }
`);
